import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19 .8a18.2 18.2 0 1 1 0 36.4A18.2 18.2 0 0 1 19 .8Zm0 33.8a15.6 15.6 0 1 0 0-31.2 15.6 15.6 0 0 0 0 31.2Zm1.95-7.15a1.95 1.95 0 1 1-3.9 0 1.95 1.95 0 0 1 3.9 0ZM19 8.6a1.3 1.3 0 0 1 1.3 1.3v11.7a1.3 1.3 0 0 1-2.6 0V9.9A1.3 1.3 0 0 1 19 8.6Z",
      fill: "#37A0EB"
    }, null, -1)
  ]))]))
}
export default { render: render }